import React, { useState } from "react";
import { Redirect } from "react-router-dom";
import { hasRoleAccess } from "../../../utils/AuthUtils";
import { ContentRoute } from "../../../_metronic/layout";
import { HomePage } from "../../pages/HomePage";

export const ProtectedRoute = ({ pageRoles, path, currentComponent }) => {
  return !hasRoleAccess(pageRoles) ? (
    <>
      <Redirect to="/" />
      <ContentRoute path="/" exact component={HomePage} />
    </>
  ) : (
    <ContentRoute path={path} exact component={currentComponent} />
  );
};
